<template lang="pug">
  v-content
    v-container
      v-layout(text-center wrap)
        v-flex(xs12)
          v-img(
            :src="require('@/assets/nouhinsyo.svg')"
            class="my-3"
            contain
            height="200"
          )
        v-flex(xs12)
          p
            h1 伝票管理Webアプリ
        v-flex(mb-4)
          v-form(model="valid")
            v-card.mx-auto(max-width="344")
              v-card-text
                v-text-field(label="ログイン名" v-model="user.login")
                v-text-field(label="パスワード" type="password" v-model="user.password")
              v-card-actions
                v-btn(outlined color="primary" @click="submit") ログイン
                v-spacer
                v-btn(text @click="cancel") キャンセル
</template>

<script>
  import debugLog from '@/utils/debugLog'
  import { newSession } from '@/api/session'

  export default {
    name: 'Login',
    data() {
      return {
        user: {
          login: '',
          password: ''
        },
        valid: true,
      }
    },
    created() {
      newSession().then(res => {
        debugLog(res)
      })
    },
    methods: {
      async submit() {
        await this.$store.dispatch('session/login', this.user)
        if (this.$store.state.session.user_id)
          this.$router.push('/sales_slip')
      },
      cancel() {
        this.$router.push('/')
      }
    }
  }
</script>
